import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M94.16 4.553 49.308 52.847 35.531 33.728c-1.433-2.166-4.675-1.97-5.834.355a3.37 3.37 0 0 0 .368 3.592l16.184 22.472a3.38 3.38 0 0 0 2.53 1.394h.203a3.38 3.38 0 0 0 2.474-1.124L99.098 9.142c1.765-1.905.807-5.008-1.724-5.585a3.38 3.38 0 0 0-3.225.996z" }, null, -1),
    _createElementVNode("path", { d: "M91.787 37.72a3.375 3.375 0 0 0-2.643 3.971c.551 2.743.83 5.534.833 8.333 0 32.034-34.678 52.055-62.421 36.038A41.61 41.61 0 0 1 6.75 50.024C6.746 18.513 40.408-1.568 68.135 13.405c2.285 1.246 5.063-.449 5-3.052a3.38 3.38 0 0 0-1.761-2.887C38.63-10.249-1.012 14.128.02 51.341c1.032 37.215 41.962 59.358 73.674 39.857a48.36 48.36 0 0 0 23.031-41.174 49.3 49.3 0 0 0-.968-9.661 3.373 3.373 0 0 0-3.97-2.643" }, null, -1)
  ])))
}
export default { render: render }